import { defineStore } from "pinia";

export const useAppStore = defineStore("app", {
  state: () => ({
    isCollapse: false, // 侧边栏是否折叠
    curPageTitle: "",
  }),
  actions: {
    // 设置侧边栏是否折叠
    setIsCollapse(collapse: boolean) {
      this.isCollapse = collapse;
    },
  },
  persist: true,
});
